"use client";
import React from "react";
// styling of swiper
import "swiper/css";
import "swiper/css/zoom";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import Swiper from "@components/common/Swiper";
import { FreeMode, Navigation, Thumbs, Zoom } from "swiper/modules";
import { get, map } from "lodash";
import styles from "./General.module.scss";
import CardSlide from "./CardSlide";
import Icon from "@components/common/Icon";
import { usePageContext } from "@providers/PageProvider";
import useSwiper from "@hooks/useSwiper";
import cx from "classnames";

const View = () => {
  const { pageData } = usePageContext();
  const images = get(pageData, "images");
  const swiperThumbs = useSwiper(".swiper-thumbs", {
    slidesPerView: 2,
    spaceBetween: 10,
    modules: [FreeMode, Navigation, Thumbs],
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  const swiper = useSwiper(
    ".swiper-product-detail",
    {
      zoom: true,
      spaceBetween: 0,
      slidesPerView: 1,
      allowTouchMove: false,
      navigation: {
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
      },
      modules: [FreeMode, Navigation, Thumbs, Zoom],
      thumbs: {
        swiper: swiperThumbs,
      },
    },
    swiperThumbs
  );
  return (
    <section className={styles.boxSlider}>
      <div className={styles.swiper}>
        <Swiper
          className={cx("swiper-product-detail")}
          swiperInner={
            <>
              <Icon className="swiper-next" name="chevron-right-outline" />
              <Icon className="swiper-prev" name="chevron-left-outline" />
            </>
          }
        >
          {map(images, (image, index) => (
            <CardSlide
              {...image}
              zoom={true}
              className={cx("swiper-slide")}
              key={`card_slide_${index}`}
            />
          ))}
        </Swiper>
      </div>
      <div className={styles.thumbs}>
        <Swiper className={cx("swiper-thumbs")}>
          {map(images, (image, index) => (
            <CardSlide
              {...image}
              className={cx("swiper-slide")}
              key={`card_thumbs_${index}`}
            />
          ))}
        </Swiper>
      </div>
    </section>
  );
};
export default View;
